import {createFeatureSelector, createSelector} from "@ngrx/store";
import {aiChatFeatureKey, AiChatState} from "./ai-chat.state";

const selectAiChatState = createFeatureSelector<AiChatState>(aiChatFeatureKey);

export const selectAiChatIsOpen = createSelector(selectAiChatState, state => state.isOpen);
export const selectAiChatMessages = createSelector(selectAiChatState, state => state.messages);
export const selectAiChatIsStreaming = createSelector(selectAiChatState, state => state.isStreaming);
export const selectAiChatStreamingText = createSelector(selectAiChatState, state => state.streamingText);
export const selectAiChatToolCallStatus = createSelector(selectAiChatState, state => state.toolCallStatus);
export const selectAiChatError = createSelector(selectAiChatState, state => state.error);
export const selectAiChatConversationId = createSelector(selectAiChatState, state => state.conversationId);
